import { useEffect } from 'react';
import Input from '../../../component/Input/input';
import { VenueDetailProps } from './type';
import { useTranslation } from 'react-i18next';
import { StorageKey } from '../../../utils/helper.type';
import { jwtDecode } from 'jwt-decode';
import { UserType } from '@inplay/models';

const VenueDetails = ({
  venueData,
  handleChange,
  handleBranchChange,
  enableContinueButton,
}: VenueDetailProps) => {
  const { t } = useTranslation();
  const accessToken = localStorage.getItem(StorageKey.ACCESS_TOKEN);
  const tokenData = jwtDecode(accessToken || '') as any;
  const userType = tokenData?.type;

  useEffect(() => {
    const hasEmptyVenueName = !venueData?.venue?.name?.trim();
    const hasEmptyBranchName = venueData?.venueBranches?.some(
      (branch) => !branch?.name?.trim(),
    );

    if (hasEmptyVenueName || hasEmptyBranchName) {
      enableContinueButton();
    }
  }, [venueData?.venue?.name, venueData?.venueBranches]);

  return (
    <div className="flex flex-col gap-6 w-full">
      <div className="flex w-full">
        <label className="w-[40%] pt-4 text-black font-helvetica text-xs font-[500] text-left">
          {t('venueSetup.venue')} *
        </label>
        <Input
          containerClassName="flex w-full"
          value={venueData?.venue?.name}
          onChange={(e) =>
            handleChange('venue', {
              ...venueData?.venue,
              name: e?.target?.value,
            })
          }
          placeholder={t('venueSetup.venuePlaceholder')}
          inputClassName="rounded-full bg-[#FAFAFA] px-6 py-3 w-full"
          required
          disabled={userType === UserType.VENUE_MANAGER}
        />
      </div>
      {venueData?.venueBranches?.length ? (
        <div className="flex flex-col gap-4">
          {venueData?.venueBranches?.map((branch) => (
            <div className="flex w-full">
              <label className="w-[40%]  pt-4 text-black font-helvetica text-xs font-[500] text-left">
                {t('venueSetup.venueBranchName')} *
              </label>
              <Input
                key={branch?.id}
                containerClassName="flex w-full"
                value={branch?.name}
                onChange={(e) =>
                  handleBranchChange(branch?.id, 'name', e?.target?.value)
                }
                placeholder={t('venueSetup.venueBranchPlaceholder')}
                inputClassName="rounded-full bg-[#FAFAFA] px-6 py-3 w-full"
                required
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default VenueDetails;
